export const ADDED_QUESTION_TYPES = {
  INSTRUCTOR: 'Instructor-added Questions',
  INSTRUCTOR_UNIT: 'InstructorAddedQuestions',
  ACADEMIC_UNIT: 'AcademicUnitAddedQuestions',
  /**
   * The course section's shared set (CR-295). Carried in the `type` search param like the others,
   * because the question screen loads exactly one set at a time into a singleton slice and that
   * param is what chooses which — see the switcher in `SharedAndMineSwitcher`.
   */
  SECTION: 'Section-added Questions'
} as const

export type AddedQuestionType = typeof ADDED_QUESTION_TYPES[keyof typeof ADDED_QUESTION_TYPES]
